module.exports = __webpack_public_path__ + "img/mopiWhite.a8fbccc2.png";